import { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '@shared/auth/AuthContext';
import { RoleGuard } from '@shared/auth/RoleGuard';
import { CustomerGate } from '@shared/auth/CustomerGate';

// Role-level lazy chunks. Each role's code is fetched only when its route matches
// AND the user has the required role (enforced both client-side and at the edge).
const PublicRoutes   = lazy(() => import('@routes/public/PublicRoutes'));
const CustomerRoutes = lazy(() => import('@routes/customer/CustomerRoutes'));
const ProviderRoutes = lazy(() => import('@routes/provider/ProviderRoutes'));
const AdminRoutes    = lazy(() => import('@routes/admin/AdminRoutes'));
const AgentRoutes    = lazy(() => import('@routes/agent/AgentRoutes'));

function Fallback() {
  return <div style={{ padding: 24 }}>Loading…</div>;
}

export default function App() {
  const { loading } = useAuth();
  if (loading) return <Fallback />;

  return (
    <Suspense fallback={<Fallback />}>
      <Routes>
        <Route path="/*" element={<PublicRoutes />} />
        <Route
          path="/customer/*"
          element={<CustomerGate><CustomerRoutes /></CustomerGate>}
        />
        <Route
          path="/provider/*"
          element={<RoleGuard role="creator"><ProviderRoutes /></RoleGuard>}
        />
        <Route
          path="/admin/*"
          element={<RoleGuard role="admin"><AdminRoutes /></RoleGuard>}
        />
        <Route
          path="/agent/*"
          element={<RoleGuard role={['field_agent', 'admin']}><AgentRoutes /></RoleGuard>}
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}
